<template>
    <div :class="styles.alert_message_parent">
        <div :class="[type === 'default' ? styles.alert : styles.alert_error]">
            <div
                :class="{'flex justify-center md:text-lg': type === 'default'}"
                class="w-full text-center"
            >
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseAlert',
  props: {
    type: {
      type: String,
      default: 'default',
      validator (value) {
        return [
          'default', 'error'
        ].includes(value)
      }
    }
  },

  data () {
    return {
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
